export enum StepStyle {
    DASHED
}
